export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ko": {
        "COMM_MANAGE_GROUP": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["그룹 관리"])},
        "COMM_MANAGE_MEMBER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["구성원 관리"])},
        "COMM_SELECT_TARGET": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["대상 선택"])}
      },
      "en": {
        "COMM_MANAGE_GROUP": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Group Management"])},
        "COMM_MANAGE_MEMBER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Member Management"])},
        "COMM_SELECT_TARGET": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select target"])}
      }
    }
  })
}
